<template>
  <div class="container-fluid container-fullheight">
    <div class="row">
      <div
        role="main"
        class="col d-block"
      >
        <section class="d-flex justify-content-between align-items-center mt-2">
          <div class="section-title py-0">
            Locations <span class="section-subtitle d-none d-sm-inline d-md-inline d-lg-inline d-xl-inline">management</span>
          </div>
        </section>
        <hr>
        <div class="row">
          <div class="col-12 col-xl-6">
            <div class="btn-group mb-4">
              <router-link
                to="/locations/create"
                class="btn btn-outline-primary"
              >
                Create Location
              </router-link>
              <router-link
                to="/locations/verification"
                class="btn btn-outline-primary"
              >
                Run Verification
              </router-link>
            </div>
            <form
              @submit.prevent="handleSearch"
            >
              <p class="font-weight-bold mb-2">
                Search locations
              </p>
              <div class="form-group mb-3">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Name or id, e.g. denia, 14399"
                  :disabled="search.loading"
                  @change="handleSearch"
                  v-model.trim="search.form.freetext"
                >
                <div
                  v-if="search.loading"
                  class="spinner-border spinner-border-sm text-primary"
                  role="status"
                >
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
            </form>
            <div
              v-if="search.showResults"
            >
              <p class="text-muted mb-2">
                {{ search.results.length == 0 ? "no " : search.results.length }} result(s) found
              </p>
              <ul
                id="location-search-results"
                class="list-unstyled list-group mb-1 pr-1 pb-1"
              >
                <li
                  v-for="result in search.results"
                  :key="result.id"
                  class="list-group-item d-flex justify-content-between"
                >
                  <div>
                    {{ result.name }}
                    <small v-if="locationHierarchyText( result ).length > 0">
                      {{ locationHierarchyText( result ) }}
                    </small>
                    <small class="text-muted">{{ result.type }} - </small>
                    <small class="text-muted">{{ result.id }}</small>
                  </div>
                  <router-link
                    :to="`/locations/${result.id}`"
                    class="btn btn-link p-0"
                  >
                    Edit
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-12 col-xl-6">
            <div
              v-if="recentlyViewedLocations.length > 0"
            >
              <p class="font-weight-bold mb-2 d-flex justify-content-between">
                Recently viewed locations
                <button
                  type="button"
                  class="btn btn-link p-0 text-danger btn-sm"
                  @click="clearRecentlyViewedLocations"
                  :disabled="search.loading"
                >
                  Remove All
                </button>
              </p>
              <ul
                id="viewed-locations"
                class="list-unstyled list-group mb-1 pr-1 pb-1"
              >
                <li
                  v-for="result in recentlyViewedLocations"
                  :key="result.id"
                  class="list-group-item d-flex justify-content-between"
                >
                  <div>
                    {{ result.name }}
                    <small class="text-muted">{{ allLocationTypes.find(t => t.key === result.type).name }} - </small>
                    <small class="text-muted">{{ result.id }}</small>
                  </div>
                  <div>
                    <router-link
                      :to="`/locations/${result.id}`"
                      class="btn btn-primary py-0 mr-2"
                    >
                      Edit
                    </router-link>
                    <button
                      type="button"
                      class="btn btn-link text-danger p-0 btn-sm"
                      @click="removeRecent(result.id)"
                      :disabled="search.loading"
                    >
                      Remove
                    </button>
                  </div>
                </li>
              </ul>
            </div>
            <hr
              v-if="recentlyViewedLocations.length > 0 && recentlyUpdatedLocations.length > 0"
              class="mt-4"
            >
            <div>
              <p class="font-weight-bold mb-2">
                Recently updated locations
                <span
                  v-if="recentlyViewedLocationsLoading"
                  class="spinner-border spinner-border-sm text-primary ml-2"
                  role="status"
                >
                  <span class="sr-only">Loading...</span>
                </span>
              </p>
              <ul
                id="viewed-locations"
                class="list-unstyled list-group mb-1 pr-1 pb-1"
                v-if="recentlyUpdatedLocations.length > 0"
              >
                <li
                  v-for="result in recentlyUpdatedLocations"
                  :key="result.id"
                  class="list-group-item d-flex justify-content-between"
                >
                  <div>
                    {{ result.name }}
                    <small class="text-muted">{{ allLocationTypes.find(t => t.key === result.type).name }} - </small>
                    <small class="text-muted">{{ result.id }}</small>
                  </div>
                  <div>
                    <router-link
                      :to="`/locations/${result.id}`"
                      class="btn btn-primary py-0"
                    >
                      Edit
                    </router-link>
                  </div>
                </li>
              </ul>
              <p
                v-else
                class="text-danger small"
              >
                {{ recentlyViewedLocationsErrorMsg }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import http from '../../http';
import locationTypes from '../../models/location-types';
import notify from '../../notifications';

export default {
    data() {
        return {
            search: {
                loading: false,
                showResults: false,
                limit: 30,
                form: {
                    locationName: '',
                    locationID: 7352,
                    idType: 'id-equals'
                },
                results: []
            },
            recentlyUpdatedLocations: [],
            recentlyViewedLocationsLoading: false,
            recentlyViewedLocationsErrorMsg: '',
            recentlyViewedLocations: JSON.parse( window.localStorage.getItem( 'recentlyViewedLocations' ) || '[]' )
        };
    },
    computed: {
        allLocationTypes() {
            return locationTypes;
        }
    },
    methods: {
        locationHierarchyText( location ) {
            let parentMunicipalities = location.relations.filter( r => r.objectType == 'municipality' );
            if ( parentMunicipalities.length > 0 ) {
                // case with multiple municipalities
                return `in ${parentMunicipalities.map( m => m.objectName ).join( '/' )} municipality`;
            }

            let parentProvinces = location.relations.filter( r => r.objectType == 'province' );
            if ( parentProvinces.length > 0 ) {
                return `in ${parentProvinces[ 0 ].objectName} province`;
            }

            return '';
        },
        removeRecent( id ) {
            let recent = JSON.parse( window.localStorage.getItem( 'recentlyViewedLocations' ) );

            recent = recent.filter( x => x.id !== id );

            this.updateRecentlyViewedLocations( recent );
        },
        async handleSearch() {
            this.search.loading = true;
            this.search.showResults = false;

            const searchParams = new URLSearchParams();
            searchParams.set( 'limit', this.search.limit.toString() );
            searchParams.set( isNaN( this.search.form.freetext ) ? 'freetext' : 'id', this.search.form.freetext );

            const response = await http.get( `locations?${searchParams.toString()}` );

            const body = await response.json();

            this.search.results = body;

            this.search.showResults = true;
            this.search.loading = false;
        },
        clearRecentlyViewedLocations() {
            this.updateRecentlyViewedLocations( [] );
        },
        updateRecentlyViewedLocations( newValue ) {
            window.localStorage.setItem( 'recentlyViewedLocations', JSON.stringify( newValue ) );
            this.recentlyViewedLocations = JSON.parse( window.localStorage.getItem( 'recentlyViewedLocations' ) );
        }
    },
    async mounted() {
        this.recentlyViewedLocationsLoading = true;

        const searchParams = new URLSearchParams();
        searchParams.set( 'limit', '20' );
        searchParams.set( 'order', 'LastUpdated' );

        const response = await http.get( `locations?${searchParams.toString()}` );

        if ( response.status !== 200 ) {
            const msg = 'Loading recently updated locations failed with status ' + response.status;

            notify( {
                type: 'error',
                text: msg,
                title: 'Failed loading recently updated locations'
            } );
            this.recentlyViewedLocationsErrorMsg = msg;
            this.recentlyViewedLocationsLoading = false;
            return;
        }

        this.recentlyUpdatedLocations = await response.json();

        this.recentlyViewedLocationsLoading = false;
    }
};
</script>
<style>
#location-search-results,
#viewed-locations,
#viewed-locations {
  overflow: auto;
}

#viewed-locations,
#viewed-locations {
  max-height: 20vh;
}

#location-search-results {
  max-height: 50vh;
}
</style>



// WEBPACK FOOTER //
// src/components/locations/Dashboard.vue